import { FC } from "react";
import styled from "styled-components";
import { Button } from "./Button";
import { Modal } from "./Modal";
import useTranslateMessage from "../hooks/useTranslateMessage";

const StyledUnsavedFormModal = styled.div`
  .UnsavedFormModal__buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-top: 16px;
  }
`;

export interface Props {
  isOpen: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

const UnsavedFormModal: FC<Props> = ({ isOpen, onCancel, onSubmit }) => {
  const t = useTranslateMessage();
  return (
    <StyledUnsavedFormModal>
      <Modal isOpen={isOpen}>
        <span>{t({ id: "UnsavedFormModal-title" })}</span>

        <div className="UnsavedFormModal__buttons">
          <Button type="button" onClick={onCancel}>
            {t({ id: "confirmationPopup-cancelText" })}
          </Button>

          <Button type="button" onClick={onSubmit}>
            {t({ id: "UnsavedFormModal-continue" })}
          </Button>
        </div>
      </Modal>
    </StyledUnsavedFormModal>
  );
};

export { UnsavedFormModal };
